export default {
    edit: 'Editar',
    location: 'Ubicación + T&C',
    filter: 'Filtrar',
};
